/* eslint-disable react/prop-types */
import React from 'react';
import clsx from 'clsx';

import { TextBlock } from 'components/Text';

import { ReactComponent as DotsIcon } from 'assets/icons/javascript/Separator.svg';

import styles from './styles.module.scss';

export const Countdown = ({
  dateDiff,
  className,
  ...props
}) => (
  <div className={clsx(className, styles?.timeBox)} {...props}>
    <div className={styles?.timeBanner}>
      <TimeSection {...{ ...dateDiff[0] }} />
      <DotsIcon className={styles?.separator} />
      <TimeSection {...{ ...dateDiff[1] }} />
      <DotsIcon className={styles?.separator} />
      <TimeSection {...{ ...dateDiff[2] }} />
      <DotsIcon className={styles?.separator} />
      <TimeSection {...{ ...dateDiff[3] }} />
    </div>
  </div>
);

function TimeSection({ lable, diff }) {
  return (
    <div className={styles?.timeEntity}>
      <TextBlock>{(diff)?.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })}</TextBlock>
      <TextBlock {...{ type: 'text5', className: styles?.entityName }}>{lable}</TextBlock>
    </div>
  );
}
